import { render } from "./MessageWrapper.vue?vue&type=template&id=7025facd"
import script from "./MessageWrapper.vue?vue&type=script&lang=js"
export * from "./MessageWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__